const messages = {
  ru: {
    phoneNumberForm: {
      title: 'Ввод номера',
      description: 'Введите номер — проверим регистрацию',
      label: 'Номер телефона',
      btnText: 'Продолжить',
      loaderTitle: 'Проверяем номер',
      loaderDesc:
        'Это может занять несколько минут. Пожалуйста, не закрывайте экран!',
      ctnError: 'Введите номер  в формате +7 XXX XXX XX XX',
      pinLabel: 'PIN1 - код',
      pinInfoDesc: 'PIN1 указан на SIM-карте',
      pinError: 'Неверный PIN1',
      pinLengthErr: 'PIN1 состоит из 4-х цифр',
      pinLoader: 'Проверяем PIN1',
      smsLoader: 'Проверяем SMS-код',
      smsLabel: 'SMS - код',
      smsLengthErr: 'SMS-код состоит из 4-х цифр',
      pinOption: 'Вход по PIN',
      smsOption: 'Вход по SMS ',
      pinErrorAttempts: 'Неверный PIN1-код. Осталось {count} попытки',
      smsErrorAttempts: 'Неверный SMS-код. Осталось {count} попытки',
      sendSms: 'Отправить SMS-код',
      resendSmsCode: 'Отправить код повторно',
    },
    phoneRegistration: {
      title: 'Регистрация номера',
      description: 'Номер не зарегистрирован. Давайте это исправим. ',
      radioBtn1: 'Гражданин РК',
      radioBtn2: 'Гражданин другой страны',
      label: 'ИИН',
      btnText: 'Продолжить',
      iinError: 'Введите ИИН в формате XXXXXXXXXXXX',
      respErrorMessage: 'Неверный ИИН',
      respErrorDesc: 'Регистрационные данные не найдены',
      consentText:
        'Нажимая «Продолжить», Вы подтверждаете согласие с условиями, описанными {link}, включая сбор и обработку персональных данных.',
      consentLink: 'здесь',
      errors: {
        maxIinSubscriberTitle: 'Внимание!',
        maxIinSubscriberDesc:
          'Превышено допустимое количество регистраций на Ваши данные',
        btnOk: 'ОК',
        btnMoreDetails: 'Подробнее',
      },
    },
    beeLiveScanner: {
      errSmthWrong: 'Что-то пошло не так ☹',
      errTitle: {
        attemptLeft: 'Верификация не пройдена',
        errSmthWrong: 'Что-то пошло не так ☹',
        errNotAllowed: 'Необходим доступ к камере',
        ageError: 'Процедура доступна только лицам, достигшим 18 лет',
      },
      errDesc: {
        attemptLeft: 'Вы исчерпали 3 попытки. Попробуйте снова через 30 минут',
        errSmthWrong: 'Попробуйте пройти верификацию заново немного позже',
        errAttack:
          'Попробуйте ещё раз. Важно: верификацию проходит тот, кто регистрирует номер на себя',
        errNotAllowed: 'Откройте доступ к камере, чтобы пройти верификацию',
      },
      errBtnText: {
        attemptLeft: 'Понятно',
        errAttack: 'Пройти снова',
        errSmthWrong: 'Хорошо',
        errNotAllowed: 'Назад',
        redirectToMyBeeline: 'Перейти в приложение',
      },
      successTitle: 'Верификация пройдена',
      successDesc: 'Мы убедились, что Вы — это Вы.',
    },
    beeLiveInstruction: {
      title: 'Верификация',
      description: 'Пора сделать селфи',
      hints: {
        title1: 'снимите головной убор и очки',
        title2: 'встаньте напротив источника света',
        title3: 'держите камеру прямо перед собой',
      },
      descriptions: {
        decs1: 'На экране будут подсказки. Пожалуйста, следуйте им.',
        decs2: 'У Вас 3 попытки.',
      },
      btnText: 'Начать верификацию',
    },
    registrationNumber: {
      loaderTitle: 'Регистрируем номер',
      loaderDesc:
        'Это может занять несколько минут. Пожалуйста, не закрывайте экран!',
      messages: {
        successTitle: 'Ура, номер зарегистрирован!',
        successDesc: 'Теперь Ваш номер оформлен на Вас',
        errTitle: 'Операция невозможна. Номер зарегистрирован на другие данные',
        errDesc: 'Проверьте введённые данные или перерегистрируйте номер',
        registrationAvailableTitle: 'Номер уже зарегистрирован',
        registrationAvailableDesc:
          'Для проверки данных регистрации установите «Janymda».',
        anotherNumberTitle: 'Номера нет в сети Beeline',
        regNumberAndDeviceAvailableTitle:
          'Номер и устройство уже зарегистрированы',
        regNumberAndDeviceAvailableDesc:
          'Пользуйтесь связью без ограничений. Управлять номером удобно в приложении «Janymda»',
      },
      btnText: 'Закрыть',
      btnBack: 'Назад',
    },
    beeDocInstruction: {
      title: 'Сейчас начнётся верификация',
      hints: {
        title1: 'Приготовьте паспорт. Его нужно отсканировать',
      },
      btnText: 'Начать верификацию',
    },
    beeDocScanner: {
      navTitle: {
        title1: 'Сканирование документа',
        title2: 'Сканирование лица',
      },
      descriptions: {
        decs1:
          'Наведите камеру на страницу паспорта с Вашими персональными данными',
      },
    },
    statusView: {
      errTitle: {
        title1: 'Что-то пошло не так ☹ ',
        siteUnavailable: 'Услуга сейчас недоступна из-за обновления систем',
      },
      errDesc: {
        decs1: 'Пожалуйста, попробуйте зарегистрировать номер ещё раз',
        decs2: 'Попробуйте позже',
        siteUnavailable: 'Воспользоваться ею пока не получится и в других наших каналах обслуживания. Понимаем, это неудобно. 17 августа всё снова заработает 🙏',
      },
      phoneNumberForm: {
        pin: {
          title: 'Превышено количество попыток ввода PIN1-кода.',
          description: 'Попробуйте снова через 3 часа',
        },
        sms: {
          title: 'Превышено количество попыток ввода SMS-кода.',
          description: 'Попробуйте снова через 3 часа',
        },
        pinAndSms: {
          title: 'Превышено количество попыток ввода PIN1 и SMS.',
          description: 'Попробуйте снова через 24 часа',
        },
      },
    },
    deviceRegistration: {
      title: 'Регистрация устройства',
      description: 'Нужно зарегистрировать устройство',
      residentLabel: 'ИИН',
      nonResidentLabel: 'Номер паспорта',
      btnText: 'Продолжить',
      iinError: 'Введите ИИН в формате XXXXXXXXXXXX',
      respErrorMessage: 'Неверный ИИН',
      messages: {
        errors: {
          anotherCase: {
            title: 'Связь заблокирована',
            description:
              'Введённые данные не совпадают с регистрационными данными владельца номера. Проверьте, на кого оформлен номер, в приложении «Janymda»',
          },
          blockedCase: {
            title: 'Устройство заблокировано',
            decs1:
              'Пожалуйста, обратитесь в офис Beeline. Мы поможем снять блокировку',
            decs2:
              'Пожалуйста, обратитесь туда, где Вы приобрели устройство или в правоохранительные органы',
          },
          registration: {
            title: 'Регистрация устройства',
            residentDesc: 'Зарегистрировать устройство на Ваш ИИН?',
            nonResidentDesc:
              'Зарегистрировать устройство на Ваши паспортные данные?',
            btn1: 'Да',
            btn2: 'Отмена',
          },
        },
        successCase: {
          title: 'Устройство зарегистрировано!',
          description:
            'Теперь Вы можете пользоваться связью Beeline без ограничений',
        },
        backBtn: 'Назад',
        redirectToMyBeeline: 'Проверить в приложении',
        loaderTitle: 'Регистрируем устройство',
        loaderDesc:
          'Это может занять несколько минут. Пожалуйста, не закрывайте экран!',
      },
    },
    numberReplacement: {
      title: 'Выберите номер из списка',
      searchTitle: 'Поиск номера',
      btns: {
        btnNext: 'Продолжить',
        btnPayment: 'К оплате ',
        btnLoader: 'Обновить статус',
        btnSuccess: 'На главную',
        btnError1: 'Обновить',
        btnError2: 'На главную',
      },
      payment: {
        cardNumberLabel: 'Номер карты',
        cardValidity: 'Срок действия',
        cardSecretCode: 'CVV/CVC',
      },
      messages: {
        errors: {
          title: 'Упс, что-то пошло не так 😔',
          description: 'Описание ошибки, почему так получилось',
        },
        loader: {
          title: 'Ваш номер меняется прямо сейчас',
          description: 'Происходит волшебство. Пожалуйста, подождите ☺',
        },
        successCase: {
          payment: {
            title: 'Оплата прошла успешно',
            description: 'Вы оплатили смену номера {amount}',
          },
          changeNumber: {
            title: 'Номер успешно изменен',
            description: 'Теперь Ваш новый номер ',
          },
        },
        errorCase: {
          title: 'Услуга Вам недоступна',
          description: '',
        },
      },
    },
    pageNotFound: {
      title: 'Страница не найдена',
      description: 'Введена некорректная ссылка',
      btnText: 'На главную',
    },
  },
  kz: {
    phoneNumberForm: {
      title: 'Нөмірді жазу',
      description: 'Нөмірді жазыңыз — тіркеуін тексереміз',
      label: 'Телефон нөмірі',
      btnText: 'Жалғастыру',
      loaderTitle: 'Нөмірді тексереміз',
      loaderDesc:
        'Ол бірнеше минут алуы мүмкін. Экранды жаппауыңызды өтінеміз!',
      ctnError: 'Нөмірді +7 XXX XXX XX XX нысанында енгізіңіз',
      pinLabel: 'PIN1 - коды',
      pinInfoDesc: 'PIN1 SIM-картада көрсетілген',
      pinError: 'Қате PIN1',
      pinLengthErr: 'PIN1 4 саннан құралған',
      pinLoader: 'PIN1-ді тексереміз',
      smsLoader: 'SMS-кодты тексеріп жатырмыз',
      smsLabel: 'SMS - код',
      smsLengthErr: 'SMS 4 саннан құралған',
      pinOption: 'PIN арқылы кіру',
      smsOption: 'SMS арқылы кіру',
      pinErrorAttempts: 'PIN1-код қате. {count} әрекет қалды',
      smsErrorAttempts: 'SMS-код қате. {count} әрекет қалды',
      sendSms: 'SMS-кодты жіберу',
      resendSmsCode: 'SMS-кодты қайта жіберу',
    },
    phoneRegistration: {
      title: 'Нөмірді тіркеу',
      description: 'Нөмір тіркелмеген. Мұны түзейік.',
      radioBtn1: 'ҚР азаматы',
      radioBtn2: 'Шетел азаматы',
      label: 'ЖСН',
      btnText: 'Жалғастыру',
      iinError: 'ЖСН-ды XXXXXXXXXXXX нысанында енгізіңіз',
      respErrorMessage: 'Қате ЖСН',
      respErrorDesc: 'Тіркеу мәліметтері табылмады',
      consentText:
        '«Жалғастыру» батырмасын баса отырып, Сіз {link} сипатталған шарттармен, соның ішінде дербес деректерді жинау және өңдеу шарттарымен келісетініңізді растайсыз.',
      consentLink: 'мұнда',
      errors: {
        maxIinSubscriberTitle: 'Назар аударыңыз!',
        maxIinSubscriberDesc:
          'Атыңызға тіркеуге рұқсат етілген шектен асып кеттіңіз',
        btnOk: 'ОК',
        btnMoreDetails: 'Толық ақпарат',
      },
    },
    beeLiveScanner: {
      errSmthWrong: 'Бір қате кетті ☹',
      errTitle: {
        attemptLeft: 'Тексеруден өтпедіңіз',
        errSmthWrong: 'Бір қате кетті ☹',
        errNotAllowed: 'Камераға кіру мүмкіндігі қажет',
        ageError: 'Процедура 18 жастан асқан тұлғаларға ғана қолжетімді',
      },
      errDesc: {
        attemptLeft:
          '3 мүмкіндігіңіз аяқталды. 30 минуттан соң қайта байқап көріңіз',
        errSmthWrong: 'Сәл кейінірек тексеруден қайта өтіп көріңіз',
        errAttack:
          'Тағы бір рет байқап көріңіз. Маңызды: нөмірді атына тіркеген тұлғалар тексеруден өтеді',
        errNotAllowed:
          'Верификацияны өту үшін камераға кіру мүмкіндігін ашыңыз',
      },
      errBtnText: {
        attemptLeft: 'Түсінікті',
        errAttack: 'Қайта өту',
        errSmthWrong: 'Жақсы',
        errNotAllowed: 'Артқа',
        redirectToMyBeeline: 'Қосымшаға өту',
      },
      successTitle: 'Тексеруден сәтті өттіңіз',
      successDesc: 'Сіз екеніңізге көзіміз жетті.',
    },
    beeLiveInstruction: {
      title: 'Тексеру',
      description: 'Селфи жасау керек',
      hints: {
        title1: 'бас киіміңіз бен көзілдірігіңізді шешіңіз',
        title2: 'жарық көзінің алдына тұрыңыз',
        title3: 'камераны алдыңызға ұстаңыз',
      },
      descriptions: {
        decs1: 'Экрандағы ақпарат бойынша әрекет етіңіз.',
        decs2: 'Сізде 3 мүмкіндік бар.',
      },
      btnText: 'Тексеруді бастау',
    },
    registrationNumber: {
      loaderTitle: 'Нөмір тіркелуде',
      loaderDesc:
        'Ол бірнеше минут алуы мүмкін. Экранды жаппауыңызды өтінеміз!',
      messages: {
        successTitle: 'Алақай, нөмір тіркелді!',
        successDesc: 'Енді нөмір атыңызға тіркелді',
        errTitle:
          'Операцияны орындау мүмкін емес. Нөмір басқа деректерге тіркелген',
        errDesc: 'Жазылған деректерді тексеріңіз немесе нөмірді қайта тіркеңіз',
        registrationAvailableTitle: 'Нөмір тіркелген',
        registrationAvailableDesc:
          'Тіркеу деректерін тексеру үшін "Менің Beeline-ымды" орнатыңыз',
        anotherNumberTitle: 'Нөмір Beeline желісінде тіркелмеген',
        regNumberAndDeviceAvailableTitle: 'Нөмір мен құрылғы тіркелген',
        regNumberAndDeviceAvailableDesc:
          'Байланысты шексіз пайдаланыңыз. «Менің Beeline-ым» қосымшасында нөмірді басқару оңай',
      },
      btnText: 'Жабу',
      btnBack: 'Артқа',
    },
    beeDocInstruction: {
      title: 'Қазір тексеру басталады',
      hints: {
        title1: 'Төлқұжатты дайындаңыз. Оны сканерлеу керек',
      },
      btnText: 'Тексеруді бастау',
    },
    beeDocScanner: {
      navTitle: {
        title1: 'Құжатты сканерлеу',
        title2: 'Бет-әлпетті сканерлеу',
      },
      descriptions: {
        decs1: 'Камераны төлқұжаттағы дербес деректеріңіз бар бетке бағыттаңыз',
      },
    },
    statusView: {
      errTitle: {
        title1: 'Бір қате кетті ☹',
        siteUnavailable: 'Қазір қызмет жүйелердің жаңартылуына байланысты жұмыс істемейді',
      },
      errDesc: {
        decs1: 'Нөмірді тағы бір тіркеп көріңізші',
        decs2: 'Тағы бір рет байқап көріңіз',
        siteUnavailable: 'Оны әзірге басқа қызмет көрсету арналарымызда да пайдалану мүмкін емес. Мұның ыңғайсыз екенін түсінеміз. 17 тамызда бәрі қайтадан жұмыс істейді 🙏',
      },
      phoneNumberForm: {
        pin: {
          title: 'PIN1-кодты енгізу әрекеттерінің саны шектен асып кетті.',
          description: '3 сағаттан кейін қайта көріңіз',
        },
        sms: {
          title: 'SMS-кодты енгізу әрекеттерінің саны шектен асып кетті.',
          description: '3 сағаттан кейін қайта көріңіз',
        },
        pinAndSms: {
          title: 'PIN1 мен SMS енгізу әрекеттерінің саны шектен асып кетті.',
          description: '24 сағаттан кейін қайта көріңіз',
        },
      },
    },
    deviceRegistration: {
      title: 'Құрылғыны тіркеу',
      description: 'Құрылғыны тіркеу керек',
      residentLabel: 'ЖСН',
      nonResidentLabel: 'Төлқұжат нөмірі',
      btnText: 'Жалғастыру',
      iinError: 'ЖСН-ды XXXXXXXXXXXX нысанында енгізіңіз',
      respErrorMessage: 'Қате ЖСН',
      messages: {
        errors: {
          anotherCase: {
            title: 'Байланыс бұғатталды',
            description:
              'Енгізілген деректер нөмір иесінің тіркеу деректерімен сәйкес келмейді. Нөмірдің кімге тіркелгенін «Менің Beeline-ым» қосымшасында тексеріңіз',
          },
          blockedCase: {
            title: 'Құрылғы бұғатталған',
            decs1:
              'Beeline кеңсесіне байланысуыңызды өтінеміз. Біз бұғаттан шығара аламыз',
            decs2:
              'Құрылғыны алған жерге немесе құқық қорғау органдарына байланысуыңызды өтінеміз',
          },
          registration: {
            title: 'Құрылғыны тіркеу',
            residentDesc: 'Сіздің ЖСН-ге құрылғыны тіркейік пе?',
            nonResidentDesc:
              'Сіздің төлқұжат деректеріңізге құрылғыны тіркейік пе?',
            btn1: 'Иә',
            btn2: 'Жою',
          },
        },
        successCase: {
          title: 'Құрылғы тіркелді!',
          description: 'Енді Beeline байланысын шектеусіз пайдалана аласыз',
        },
        backBtn: 'Артқа',
        redirectToMyBeeline: 'Қосымшада тексеру',
        loaderTitle: 'Құрылғы тіркелуде',
        loaderDesc:
          'Ол бірнеше минут алуы мүмкін. Экранды жаппауыңызды өтінеміз!',
      },
    },
    numberReplacement: {
      title: 'Тізімнен нөмірді таңдаңыз',
      searchTitle: 'Нөмірді іздеу',
      btns: {
        btnNext: 'Жалғастыру',
        btnPayment: 'Төлем үшін ',
        btnLoader: 'Күйді жаңарту',
        btnSuccess: 'Басты бетке',
        btnError1: 'Жаңарту',
        btnError2: 'Басты бетке',
      },
      payment: {
        cardNumberLabel: 'Карта нөмірі',
        cardValidity: 'Қолданылу мерзімі',
        cardSecretCode: 'CVV/CVC',
      },
      messages: {
        loader: {
          title: 'Сіздің нөміріңіз қазір өзгеруде',
          description: 'Сиқыр болып жатыр. Күте тұрыңыз ☺',
        },
        errors: {
          title: 'Ой, бірдеңе дұрыс болмады 😔',
          description: 'Қатенің сипаттамасы, неге бұл орын алды',
        },
        successCase: {
          payment: {
            title: 'Төлем сәтті өтті',
            description: 'Сіз нөмірді өзгерту үшін {amount} төледіңіз',
          },
          changeNumber: {
            title: 'Нөмір сәтті өзгерді',
            description: 'Енді Сіздің жаңа нөміріңіз ',
          },
        },
        errorCase: {
          title: 'Қызмет Сіз үшін қолжетімсіз',
          description: '',
        },
      },
    },
  },
  en: {
    phoneNumberForm: {
      title: 'Phone Number Entry',
      description: 'Enter your number to verify registration',
      label: 'Phone number',
      btnText: 'Continue',
      loaderTitle: 'Verifying the number',
      loaderDesc:
        'This may take a few minutes. Please do not close this screen!',
      ctnError: 'Enter the number in the format +7 XXX XXX XX XX',
      pinLabel: 'PIN1 code',
      pinInfoDesc: 'PIN1 is printed on the SIM card',
      pinError: 'Invalid PIN1',
      pinLengthErr: 'PIN1 is 4 digits',
      pinLoader: 'Verifying PIN1',
      smsLoader: 'Verifying SMS code',
      smsLabel: 'SMS code',
      smsLengthErr: 'The SMS code is 4 digits',
      pinOption: 'Sign in with PIN',
      smsOption: 'Sign in with SMS',
      pinErrorAttempts: 'Invalid PIN1 code. {count} attempts remaining',
      smsErrorAttempts: 'Invalid SMS code. {count} attempts remaining',
      sendSms: 'Send SMS code',
      resendSmsCode: 'Resend code',
    },
    phoneRegistration: {
      title: 'Phone Number Registration',
      description: 'The number is not registered. Let’s fix that. ',
      radioBtn1: 'Citizen of Kazakhstan',
      radioBtn2: 'Foreign citizen',
      label: 'IIN/Residence permit',
      btnText: 'Continue',
      iinError: 'Enter the IIN in the format XXXXXXXXXXXX',
      respErrorMessage: 'Invalid IIN',
      respErrorDesc: 'Registration data not found',
      consentText: 'By clicking “Continue,” you confirm that you agree to the terms described {link}, including the collection and processing of personal data',
      consentLink: 'here',
      errors: {
        maxIinSubscriberTitle: 'Attention!',
        maxIinSubscriberDesc:
          'The maximum number of registrations for your data has been exceeded',
        btnOk: 'OK',
        btnMoreDetails: 'Learn more',
      },
    },
    beeLiveScanner: {
      errSmthWrong: 'Something went wrong ☹',
      errTitle: {
        attemptLeft: 'Verification failed',
        errSmthWrong: 'Something went wrong ☹',
        errNotAllowed: 'Camera access is required',
        ageError:
          'This procedure is available only to individuals aged 18 and over',
      },
      errDesc: {
        attemptLeft:
          'You have reached the limit of 3 attempts. Try again in 30 minutes',
        errSmthWrong: 'Try verification again a little later',
        errAttack:
          'Try again. Important: verification must be performed by the person registering the number in their name',
        errNotAllowed: 'Allow camera access to complete verification',
      },
      errBtnText: {
        attemptLeft: 'Understood',
        errAttack: 'Retry',
        errSmthWrong: 'OK',
        errNotAllowed: 'Back',
        redirectToMyBeeline: 'Open the app',
      },
      successTitle: 'Verification successful',
      successDesc: 'We have confirmed your identity.',
    },
    beeLiveInstruction: {
      title: 'Verification',
      description: 'Time to take a selfie',
      hints: {
        title1: 'Remove any headwear and glasses',
        title2: 'Stand facing a light source',
        title3: 'Hold the camera directly in front of you',
      },
      descriptions: {
        decs1: 'There will be on-screen prompts. Please follow them.',
        decs2: 'You have 3 attempts.',
      },
      btnText: 'Start verification',
    },
    registrationNumber: {
      loaderTitle: 'Registering the number',
      loaderDesc:
        'This may take a few minutes. Please do not close the screen!',
      messages: {
        successTitle: 'Success! The number has been registered!',
        successDesc: 'Your number is now registered in your name',
        errTitle:
          'Operation unavailable. The number is registered under different details',
        errDesc: 'Check the entered details or re-register the number',
        registrationAvailableTitle: 'The number is already registered',
        registrationAvailableDesc:
          'To check the registration details, install "Janymda".',
        anotherNumberTitle: 'The number is not on the Beeline network',
        regNumberAndDeviceAvailableTitle:
          'The number and device are already registered',
        regNumberAndDeviceAvailableDesc:
          'Use the service without restrictions. Manage your number in the "Janymda" app',
      },
      btnText: 'Close',
      btnBack: 'Back',
    },
    beeDocInstruction: {
      title: 'Verification will start now',
      hints: {
        title1: 'Prepare your passport. It needs to be scanned',
      },
      btnText: 'Start verification',
    },
    beeDocScanner: {
      navTitle: {
        title1: 'Document scanning',
        title2: 'Face scanning',
      },
      descriptions: {
        decs1:
          'Point the camera at the passport page with your personal details',
      },
    },
    statusView: {
      errTitle: {
        title1: 'Something went wrong ☹',
        siteUnavailable: 'The service is currently unavailable due to system updates',
      },
      errDesc: {
        decs1: 'Please try registering the number again',
        decs2: 'Try again later',
        siteUnavailable: 'It is also temporarily unavailable through our other service channels. We understand this is inconvenient. Everything will be back up and running on August 17 🙏',
      },
      phoneNumberForm: {
        pin: {
          title: 'PIN1 attempt limit exceeded.',
          description: 'Try again in 3 hours',
        },
        sms: {
          title: 'SMS code attempt limit exceeded.',
          description: 'Try again in 3 hours',
        },
        pinAndSms: {
          title: 'PIN1 and SMS attempt limits exceeded.',
          description: 'Try again in 24 hours',
        },
      },
    },
    deviceRegistration: {
      title: 'Device registration',
      description: 'Device registration is required',
      residentLabel: 'IIN',
      nonResidentLabel: 'Passport number',
      btnText: 'Continue',
      iinError: 'Enter the IIN in the format XXXXXXXXXXXX',
      respErrorMessage: 'Invalid IIN',
      messages: {
        errors: {
          anotherCase: {
            title: 'Service blocked',
            description:
              'The entered data does not match the number owner’s registration details. Check who the number is registered to in the "Janymda" app',
          },
          blockedCase: {
            title: 'Device blocked',
            decs1:
              'Please visit a Beeline office. We will help remove the block',
            decs2:
              'Please contact the place of purchase or law enforcement authorities',
          },
          registration: {
            title: 'Device registration',
            residentDesc: 'Register the device to your IIN?',
            nonResidentDesc: 'Register the device to your passport details?',
            btn1: 'Yes',
            btn2: 'Cancel',
          },
        },
        successCase: {
          title: 'Device registered!',
          description: 'You can now use Beeline services without restrictions',
        },
        backBtn: 'Back',
        redirectToMyBeeline: 'Check in the app',
        loaderTitle: 'Registering the device',
        loaderDesc:
          'This may take a few minutes. Please do not close the screen!',
      },
    },
    numberReplacement: {
      title: 'Выберите номер из списка',
      searchTitle: 'Поиск номера',
      btns: {
        btnNext: 'Продолжить',
        btnPayment: 'К оплате ',
        btnLoader: 'Обновить статус',
        btnSuccess: 'На главную',
        btnError1: 'Обновить',
        btnError2: 'На главную',
      },
      payment: {
        cardNumberLabel: 'Номер карты',
        cardValidity: 'Срок действия',
        cardSecretCode: 'CVV/CVC',
      },
      messages: {
        errors: {
          title: 'Упс, что-то пошло не так 😔',
          description: 'Описание ошибки, почему так получилось',
        },
        loader: {
          title: 'Ваш номер меняется прямо сейчас',
          description: 'Происходит волшебство. Пожалуйста, подождите ☺',
        },
        successCase: {
          payment: {
            title: 'Оплата прошла успешно',
            description: 'Вы оплатили смену номера {amount}',
          },
          changeNumber: {
            title: 'Номер успешно изменен',
            description: 'Теперь Ваш новый номер ',
          },
        },
        errorCase: {
          title: 'Услуга Вам недоступна',
          description: '',
        },
      },
    },
  },
}
export default messages
